/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Highlight_Settings_Center_BottomInputs */

const en_highlight_settings_center_bottom = /** @type {(inputs: Highlight_Settings_Center_BottomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Center bottom`)
};

const es_highlight_settings_center_bottom = /** @type {(inputs: Highlight_Settings_Center_BottomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro inferior`)
};

/**
* | output |
* | --- |
* | "Center bottom" |
*
* @param {Highlight_Settings_Center_BottomInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const highlight_settings_center_bottom = /** @type {((inputs?: Highlight_Settings_Center_BottomInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Highlight_Settings_Center_BottomInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_highlight_settings_center_bottom(inputs)
	return en_highlight_settings_center_bottom(inputs)
});